import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from '../../../hooks/useTranslation';
import BaseErrorPage from '../../../views/ErrorPages';
function PageNotFound() {
    useTranslation();
    return (_jsx(BaseErrorPage, { title: "404", subTitle: "Page not found", description: "Sorry, but we can't seem to find the page you are looking for." }));
}
export default PageNotFound;
